import { stringToColor } from './colorUtils';

export default function BadgeColorHash({ id, className = '', children = null, ... otherProps }) {
  const hashedColor = (id ? stringToColor(id, {white: 0.5}) : '#000000');
  // Make a second random color to separate them even more in case they fell on similar colors
  const hashedColor2 = (id ? stringToColor(id+id, {white: 0.3}) : '#000000');

  return <span className={`badge badge-light ${className}`}
    title={id}
    key={id}
    style={{ backgroundColor: hashedColor, border: `1px solid ${hashedColor2}`, boxShadow: `1px 2px 0px 0px ${hashedColor2}` }}
    {... otherProps}>
    {children || id}
  </span>
}
